export enum SseResponseEnum {
    TestResponse = 'TEST',
}